<template>
  <LoadingSpinner v-if="loadingPage" />
  <div v-else class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-header pb-0 border-bottom">
            <div class="d-flex justify-content-center align-items-center">
              <div class="col-md-12">
                <h6>
                  <b>Enganches</b>
                </h6>
              </div>
            </div>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="table-responsive">
                <table class="table table">
                  <thead>
                    <tr class="text-center">
                      <th
                        class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                      >
                        Porcentaje
                      </th>
                      <th
                        class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                      >
                        Interés
                      </th>
                      <th
                        class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                      ></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      class="text-center"
                      v-for="enganche in enganches"
                      :key="enganche.id"
                    >
                      <td class="align-middle">
                        <span class="text-dark text-xs font-weight-bold"
                          >{{ enganche.porcentaje }}%</span
                        >
                      </td>
                      <td class="align-middle">
                        <span class="text-secondary text-xs font-weight-bold"
                          >{{ enganche.interes }}%</span
                        >
                      </td>
                      <td class="align-middle">
                        <button
                          class="text-secondary font-weight-bold text-xs btn-xs mb-0 btn btn-link p-0"
                          @click="openModal(enganche)"
                        >
                          <i class="ri-pencil-line me-1"></i>Modificar
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal -->
  <div
    class="modal fade"
    id="staticBackdrop"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
    tabindex="-1"
    aria-labelledby="staticBackdropLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-sm modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h1 class="modal-title fs-5" id="staticBackdropLabel">
            Porcentaje: {{ porcentaje }}<small class="text-sm">%</small>
          </h1>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            ref="Close"
          ></button>
        </div>
        <form method="POST" @submit.prevent="updateEnganche" id="formEnganche">
          <div class="modal-body">
            <div class="row">
              <div class="form-group col-12">
                <label>Interés</label>
                <input
                  type="tel"
                  class="form-control"
                  v-model="interes"
                  name="interes"
                  required
                  autocomplete="off"
                />
              </div>
            </div>
          </div>
          <div class="modal-footer justify-content-center">
            <button
              type="submit"
              class="btn bg-gradient-primary btn-xs"
              :disabled="isLoading"
            >
              <span
                v-if="isLoading"
                class="spinner-border spinner-border-sm me-1"
                role="status"
                aria-hidden="true"
              ></span>
              Guardar
            </button>
            <button
              type="button"
              class="btn bg-gradient-danger btn-xs"
              data-bs-dismiss="modal"
            >
              Cancelar
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import LoadingSpinner from "@/components/LoadingComponent";
import { exceptionRequestMsg, showToast } from "@/assets/js/util";
const bootstrap = require("bootstrap/dist/js/bootstrap.bundle.js");
import appApi from "@/services/api";
export default {
  data() {
    return {
      isLoading: false,
      loadingPage: true,
      enganches: [],
      interes: "",
      porcentaje: "",
      id_enganche: "",
    };
  },
  components: {
    LoadingSpinner,
  },
  methods: {
    async fetchEnganches() {
      this.enganches = [];
      this.loadingPage = true;
      try {
        const response = await appApi().get("arrendamientos/enganches");
        this.enganches = response.data;
        this.loadingPage = false;
      } catch (e) {
        exceptionRequestMsg(e);
      }
    },
    openModal(enganche) {
      const { id, porcentaje, interes } = enganche;

      this.id_enganche = id;
      this.porcentaje = porcentaje;
      this.interes = interes;

      const myModal = new bootstrap.Modal(
        document.getElementById("staticBackdrop")
      );

      myModal.show();
    },
    async updateEnganche() {
      this.isLoading = true;
      const form = document.getElementById("formEnganche");
      const formData = new FormData(form);
      formData.append("_method", "PUT");
      try {
        const response = await appApi().post(
          `arrendamientos/enganches/${this.id_enganche}/update`,
          formData
        );

        this.isLoading = false;
        const { status, message } = response.data;

        if (!status) {
          showToast(message, "error");
          return;
        }

        this.$refs.Close.click();
        showToast(message, "success");
        this.fetchEnganches();
      } catch (e) {
        this.isLoading = false;
        exceptionRequestMsg(e);
      }
    },
  },
  created() {
    this.fetchEnganches();
  },
};
</script>
